module.exports = __webpack_public_path__ + "static/media/1.6c19bcfa.png";